import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=7df64b63&scoped=true&"
import script from "./TestimonialCard.vue?vue&type=script&lang=js&"
export * from "./TestimonialCard.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialCard.vue?vue&type=style&index=0&id=7df64b63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df64b63",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/TestimonialCard.vue
// module id = null
// module chunks = 